module.exports = __webpack_public_path__ + "img/IGNIS-GL-GRIS-ACERO.431e6e4c.png";